import axios, { AxiosResponse, AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { S3PresignedUrlData } from 'types/s3Upload';

interface S3UploadParams {
    urlData: S3PresignedUrlData;
    file: File;
    id: string;
}

const uploadAsset = async ({ urlData, file }: S3UploadParams): Promise<AxiosResponse<any>> => {
    const isPostUpload = !!urlData.fields; // POST = formData, PUT = raw

    if (isPostUpload) {
        const formData = new FormData();
        Object.entries(urlData.fields).forEach(([key, value]) => {
            if (value != null) formData.append(key, value as string);
        });
        formData.append('file', file);

        return axios.post(urlData.url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    // PUT flow
    return axios.put(urlData.url, file, {
        headers: {
            'Content-Type': file.type,
        },
    });
};

export const useS3Upload = <TError = AxiosError, TContext = unknown>(
    options?: UseMutationOptions<AxiosResponse<any>, TError, S3UploadParams, TContext>,
) => useMutation({
        mutationFn: uploadAsset,
        ...options,
    });

export default useS3Upload;
